import React from 'react'
import IntroSection from '../components/IntroSection'
import DetailGrid from '../components/DetailGrid'
import Dynamics from './Dynamics'
import { useRecoilState } from 'recoil'
import { detailedResultState } from '../../../utils/recoil'
import { useTranslation } from 'react-i18next'

const Relationship = () => {
  const [data] = useRecoilState(detailedResultState);
  const { t } = useTranslation("result");
  return (
    <div>
        <IntroSection text={data?.relationships?.introduction} />
        <DetailGrid number={"1"} title={t("grid6")} example={data?.relationships?.strengths?.example} data={data?.relationships?.strengths?.data} />
        <DetailGrid number={"2"} title={t("grid7")} example={data?.relationships?.struggle?.example} data={data?.relationships?.struggle?.data} />
        <Dynamics />
    </div>
  )
}

export default Relationship